export default __webpack_public_path__ + "static/media/insta_6.c934522e.svg";